webpackJsonp([1],{

/***/ "+7QF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__ = __webpack_require__("6nJW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3308c85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__ = __webpack_require__("zNoj");
function injectStyle (ssrContext) {
  __webpack_require__("kt5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3308c85e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Check_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3308c85e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Check_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "01ru":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0FDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      atrasados: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/own').then(function (response) {
      _this.stores = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/atrasados/' + localStorage.getItem('global-store')).then(function (response) {
      _this.spinner = false;_this.atrasados = response.data;
    });
  },

  methods: {
    setStore: function setStore() {
      localStorage.setItem('global-store', this.store);
      location.reload();
    }
  }
});

/***/ }),

/***/ "0zyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


//export const http = axios.create({ baseURL: 'http://api.checkpoint.recco.com.br/api' })
var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: 'https://qualipoint-ws.uses.com.br/api' });
//export const http = axios.create({ baseURL: 'http://qualipointrecco-ws/api' })
//export const http = axios.create({ baseURL: 'http://192.168.1.17/qualipointrecco-ws/public_html/api' }) //by celular.

/***/ }),

/***/ "2xEN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5zZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome___default.a, TheMask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__["TheMask"] },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novoCheck: { grupo: null, nome: null, descricao: null, frequencia: null, peso: null, modelo: null },
      editarCheck: { check: null, grupo: null, nome: null, descricao: null, frequencia: null, peso: null, status: null, modelo: null },
      groups: [],
      models: [],
      checks: [],
      txt: ''
    };
  },
  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
    if (localStorage.getItem('admin') == 'false') this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/all').then(function (response) {
      _this.checks = response.data;console.log(_this.checks);
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/groups').then(function (response) {
      _this.groups = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/model/all').then(function (response) {
      _this.models = response.data;
    });
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
    },
    newCheck: function newCheck(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (!this.novoCheck.nome || !this.novoCheck.frequencia || !this.novoCheck.peso || !this.novoCheck.modelo) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe o nome, a frequência e o peso do novo check.',
          dangerMode: true
        });
      } else {
        var json = {
          id_group: this.novoCheck.grupo,
          nm_check: this.novoCheck.nome,
          ds_check: this.novoCheck.descricao,
          nr_freq: this.novoCheck.frequencia,
          nr_factor: this.novoCheck.peso,
          st_check: true,
          id_model: this.novoCheck.modelo };

        // Requisição para gravar o novo check.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/new', json).then(function (response) {
          _this2.clearData();
          _this2.$refs.modalNew.hide();
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
            icon: 'success',
            title: 'Ok!',
            text: 'Novo check cadastrado.'
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/all').then(function (response) {
            _this2.checks = response.data;
          });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      }
    },
    editCheck: function editCheck(evt) {
      var _this3 = this;

      evt.preventDefault();
      if (!this.editarCheck.nome || !this.editarCheck.frequencia || !this.editarCheck.peso || !this.editarCheck.modelo) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe o nome, a frequência e o peso do novo check.',
          dangerMode: true
        });
      } else {
        var json = {
          id_check: this.editarCheck.check,
          id_group: this.editarCheck.grupo,
          nm_check: this.editarCheck.nome,
          ds_check: this.editarCheck.descricao,
          nr_freq: this.editarCheck.frequencia,
          nr_factor: this.editarCheck.peso,
          st_check: this.editarCheck.status,
          id_model: this.editarCheck.modelo };

        // Requisição para gravar as alterações.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/update', json).then(function (response) {
          _this3.clearData();
          _this3.$refs.modalEdit.hide();
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
            icon: 'success',
            title: 'Ok!',
            text: 'Informações salvas.'
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/all').then(function (response) {
            _this3.checks = response.data;
          });
        });
      }
    },
    changeStatus: function changeStatus(check) {
      var _this4 = this;

      if (check.st_check == 1) {
        check.st_check = 0;
        this.txt = 'inativado';
      } else {
        check.st_check = 1;
        this.txt = 'Ativado';
      }

      var json = {
        id_check: check.id_check,
        id_group: check.id_group,
        nm_check: check.nm_check,
        ds_check: check.ds_check,
        nr_freq: check.nr_freq,
        nr_factor: check.nr_factor,
        st_check: check.st_check,
        id_model: check.id_model };
      console.log(json);
      // Requisição para inativar o check.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/update', json).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
          icon: 'success',
          title: 'Salvo!',
          text: 'Check ' + _this4.txt + '.'
        });
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/all').then(function (response) {
          _this4.checks = response.data;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    setCheck: function setCheck(check) {
      this.editarCheck.check = check.id_check;
      this.editarCheck.grupo = check.id_group;
      this.editarCheck.nome = check.nm_check;
      this.editarCheck.descricao = check.ds_check;
      this.editarCheck.frequencia = check.nr_freq;
      this.editarCheck.peso = check.nr_factor;
      this.editarCheck.status = check.st_check;
      this.editarCheck.modelo = check.id_model;
    },
    clearData: function clearData(evt) {
      this.novoCheck.grupo = null;
      this.novoCheck.nome = null;
      this.novoCheck.descricao = null;
      this.novoCheck.frequencia = null;
      this.novoCheck.peso = null;
      this.novoCheck.modelo = null;
      this.editarCheck.check = null;
      this.editarCheck.grupo = null;
      this.editarCheck.nome = null;
      this.editarCheck.descricao = null;
      this.editarCheck.frequencia = null;
      this.editarCheck.peso = null;
      this.editarCheck.status = null;
      this.editarCheck.modelo = null;
    }
  }
});

/***/ }),

/***/ "6nJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      spinner: true,
      back: false,
      check: [],
      messages: [],
      newMessage: null,
      image: '',
      filename: '',
      imagens: [],
      mainProps: { blank: true, width: 100, height: 100, class: 'm1' },
      openImage: '',
      isLoading: false,
      fullPage: true
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    // Verifica se está definida as informações dos parâmetros que são apagadas em caso de reload da página.
    if (this.$route.params.store && this.$route.params.check) {
      // Armazenando a loja e o check no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store);
      localStorage.setItem('id_check', this.$route.params.check);
      // Supervisor
      if (localStorage.getItem('level') == 'supervisor') {
        // Iniciar o check.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + this.$route.params.store + '/' + this.$route.params.check).then(function (response) {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          _this.spinner = false;
          _this.back = true;
          _this.check = response.data;
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this.admin + '/' + response.data.id_result).then(function (response) {
            _this.messages = response.data;
          });
        });
      }

      // Loja
      if (localStorage.getItem('level') == 'store') {
        // Iniciar o check.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + this.$route.params.store + '/' + this.$route.params.check).then(function (response) {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          _this.spinner = false;
          _this.back = true;
          _this.check = response.data;
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this.admin + '/' + response.data.id_result).then(function (response) {
            _this.messages = response.data;
          });
        });
      }
    } else {
      // Verifica se existe a última loja visitada no localStorage.
      if (localStorage.getItem('id_store') && localStorage.getItem('id_check')) {
        // Supervisor
        if (localStorage.getItem('level') == 'supervisor') {
          // Iniciar o check.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + localStorage.getItem('id_store') + '/' + localStorage.getItem('id_check')).then(function (response) {
            // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
            _this.spinner = false;
            _this.back = true;
            _this.check = response.data;
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this.admin + '/' + response.data.id_result).then(function (response) {
              _this.messages = response.data;
            });
          });
        }

        // Loja
        if (localStorage.getItem('level') == 'store') {
          // Iniciar o check.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + localStorage.getItem('id_store') + '/' + localStorage.getItem('id_check')).then(function (response) {
            // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
            _this.spinner = false;
            _this.back = true;
            _this.check = response.data;
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this.admin + '/' + response.data.id_result).then(function (response) {
              _this.messages = response.data;
            });
          });
        }
      }
    }
  },

  methods: {
    checkOk: function checkOk() {
      var _this2 = this;

      // Requisição para gravar o check como ok.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '0', st_result: '1' }).then(function (response) {
        _this2.backButton();
      });
    },
    checkFail: function checkFail() {
      var _this3 = this;

      this.isLoading = true;
      // Requisição para gravar o check como com problemas.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '1', st_result: '0' }).then(function (response) {
        _this3.isLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + _this3.check.id_store + '/' + _this3.check.id_check).then(function (response) {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          _this3.spinner = false;
          _this3.check = response.data;
          _this3.newMessage = 'Check iniciado com problemas.';
          _this3.sendMessage();
        });
      });
    },
    checkOpen: function checkOpen() {
      var _this4 = this;

      this.isLoading = true;
      // Requisição para gravar o check com considerações.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/salvar', { id_store: this.check.id_store, id_check: this.check.id_check, nm_check: this.check.nm_check, vl_result: '0', st_result: '0' }).then(function (response) {
        _this4.isLoading = false;
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/iniciar/' + _this4.check.id_store + '/' + _this4.check.id_check).then(function (response) {
          // Verifica se a requisição para iniciar o check é o mesmo que o WS autoriza.
          _this4.spinner = false;
          _this4.check = response.data;
          _this4.newMessage = 'Check iniciado com considerações.';
          _this4.sendMessage();
        });
      });
    },
    checkClose: function checkClose(vl_result) {
      var _this5 = this;

      // Requisição para encerrar o check.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/encerrar', { id_result: this.check.id_result, vl_result: vl_result }).then(function (response) {
        _this5.backButton();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    backButton: function backButton() {
      this.$router.go(-1);
    },
    sendMessage: function sendMessage() {
      var _this6 = this;

      // Verifica se o campo de mensagem foi preenchido.
      if (this.newMessage == null) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({ type: 'error', title: 'Erro...', text: 'Digite uma mensagem.' });
        return false;
      }
      // JSON a ser enviado para o webservice.
      var json = this.getJson();
      // Requisição para salvar a mensagem.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/message/save/' + this.check.id_result, json).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this6.admin + '/' + _this6.check.id_result).then(function (response) {
          _this6.messages = response.data;
          _this6.sendNotification(json);
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: 'Não foi possível salvar a mensagem.'
        });
      });
    },
    openCamera: function openCamera() {
      document.getElementById('camera').click();
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var _this7 = this;

      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        vm.image = e.target.result;
        _this7.sendPhoto();
      };
      reader.readAsDataURL(file);
      vm.filename = file.name;
    },
    sendPhoto: function sendPhoto() {
      var _this8 = this;

      this.isLoading = true;
      var json = { id_result: this.check.id_result, nm_image: this.filename, nm_sender: localStorage.getItem('nm_user'), admin: localStorage.getItem('admin'), dt_image: new Date().toLocaleString(), image: this.image };
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/image/save', json).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/message/all/' + _this8.admin + '/' + _this8.check.id_result).then(function (response) {
          _this8.messages = response.data;
          _this8.isLoading = false;
          var json = _this8.getJson();
          _this8.sendNotification(json);
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: 'Imagem não salva.'
        });
      });
    },
    getImage: function getImage() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/image/all/' + this.check.id_result).then(function (response) {
        _this9.imagens = response.data;
      });
    },
    openImg: function openImg(url) {
      this.openImage = url;
      this.$refs.myModalRef.show();
    },
    getJson: function getJson() {
      var json = { id_result: this.check.id_result, ds_message: this.newMessage, nm_sender: localStorage.getItem('nm_user'), id_store: this.check.id_store, admin: localStorage.getItem('admin'), user: localStorage.getItem('user'), nm_check: this.check.nm_check
        // Limpando o campo de mensagem.
      };this.newMessage = null;
      return json;
    },
    sendNotification: function sendNotification(json) {
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/message/notification/' + this.check.id_result, json).then(function (response) {});
    }
  }
});

/***/ }),

/***/ "6xNI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8bRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row mt-4 mb-4 no-gutters"},[_c('div',{staticClass:"col-2"},[(_vm.admin == 'true')?_c('b-dropdown',{attrs:{"variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('icon',{staticClass:"btn-menu",attrs:{"name":"bars","scale":"1.5"}})],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'stores' }}},[_vm._v("Lojas")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'users' }}},[_vm._v("Usuários")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'checks' }}},[_vm._v("Checks")])],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-8 text-center"},[_c('b-img',{staticStyle:{"width":"100%","max-width":"200px"},attrs:{"src":"http://api.checkpoint.recco.com.br/image_recco/recco.png","fluid":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('button',{staticClass:"btn-logoff",on:{"click":function($event){return _vm.logout()}}},[_c('icon',{attrs:{"name":"sign-out","scale":"2"}})],1)])]),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store),expression:"store"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.store=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setStore()}]}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todas as Lojas")]),_vm._v(" "),_vm._l((_vm.stores),function(store,index){return _c('option',{key:'store-'+index,domProps:{"value":store.id_store}},[_vm._v(_vm._s(store.nm_store))])})],2)])]):_vm._e(),_vm._v(" "),_c('b-card-group',{attrs:{"deck":""}},[(_vm.level == 'supervisor')?_c('div',{staticClass:"ranking card text-white bg-info mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'ranking' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.ranking),expression:"spinner.ranking"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" Ranking")]),_vm._v(" "),_vm._l((_vm.ranking.stores),function(ranking,index){return (index < 10)?_c('div',{key:'r-'+index,staticClass:"row pt-1 pb-1"},[_c('b-col',{staticClass:"text-truncate",attrs:{"cols":"6"}},[_vm._v(_vm._s(ranking.ranking)+"º "+_vm._s(ranking.nm_store))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-progress',{attrs:{"show-value":"","height":"26px","variant":"warning","value":ranking.sc_store}})],1)],1):_vm._e()})],2)])],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('div',{staticClass:"ranking card text-white bg-info mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'score', params: { store: _vm.ranking.id_store }}}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.ranking),expression:"spinner.ranking"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" "+_vm._s(_vm.ranking.nm_store))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.spinner.ranking),expression:"!spinner.ranking"}],staticClass:"row score"},[_c('b-col',{attrs:{"cols":"5"}},[_c('span',[_vm._v(_vm._s(_vm.ranking.ranking)+"º")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.ranking.score))]),_vm._v(" Score")])])],1)])])],1):_vm._e(),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"checks card text-white bg-danger mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'atrasados' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.atrasados),expression:"spinner.atrasados"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_vm._v(_vm._s(_vm.atrasados.size))],1),_vm._v(" Atrasados")]),_vm._v(" "),_vm._l((_vm.atrasados.checks),function(atrasado,index){return _c('div',{key:'at-'+index,staticClass:"row pb-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('strong',[_vm._v(_vm._s(atrasado.days))]),_vm._v(" "),(atrasado.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(atrasado.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"8"}},[_c('span',[_vm._v(_vm._s(atrasado.nm_check))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(atrasado.nm_store))])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'atrasado', store: atrasado.id_store, check: atrasado.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1)],1)],1)})],2)])],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('div',{staticClass:"checks card text-white bg-danger mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'atrasados' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.atrasados),expression:"spinner.atrasados"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_vm._v(_vm._s(_vm.atrasados.size))],1),_vm._v(" Atrasados")]),_vm._v(" "),_vm._l((_vm.atrasados.checks),function(atrasado,index){return _c('div',{key:'at-'+index,staticClass:"row pb-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('strong',[_vm._v(_vm._s(atrasado.days))]),_vm._v(" "),(atrasado.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(atrasado.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"8"}},[_c('span',[_vm._v(_vm._s(atrasado.nm_check))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(atrasado.nm_store))])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: atrasado.id_store, check: atrasado.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1)],1)],1)})],2)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"checks card text-white bg-warning mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'abertos' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.abertos),expression:"spinner.abertos"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_vm._v("\n                      "+_vm._s(_vm.abertos.size)+"\n                  ")],1),_vm._v("\n                  Trabalhando")]),_vm._v(" "),_vm._l((_vm.abertos.checks),function(aberto,index){return _c('div',{key:'ab-'+index,staticClass:"row pb-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('strong',[_vm._v(_vm._s(aberto.days))]),_vm._v(" "),(aberto.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(aberto.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"8"}},[_c('span',[_vm._v(_vm._s(aberto.nm_check))]),_vm._v(" "),(aberto.new_post > 0)?_c('icon',{attrs:{"id":"newPost","name":"circle","scale":"0.7"}}):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(aberto.nm_store))])],1),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'aberto', store: aberto.id_store, check: aberto.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1)],1)],1)})],2)])],1),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"checks card text-white bg-success mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'proximos' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.proximos),expression:"spinner.proximos"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" Próximos")]),_vm._v(" "),_vm._l((_vm.proximos.checks),function(proximo,index){return _c('div',{key:'pr-'+index,staticClass:"row pb-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('strong',[_vm._v(_vm._s(proximo.days))]),_vm._v(" "),(proximo.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(proximo.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"8"}},[_c('span',[_vm._v("\n                          "+_vm._s(proximo.nm_check)+"\n                          "),(proximo.dt_holiday_dif > 0)?_c('span',{staticClass:"holiday"},[_vm._v("(Férias)")]):_vm._e()]),_vm._v(" "),_c('h4',[_vm._v("\n                          "+_vm._s(proximo.nm_store)+"\n                        ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'proximo', store: proximo.id_store, check: proximo.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1)],1)],1)})],2)])],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('div',{staticClass:"checks card text-white bg-success mt-2",staticStyle:{"min-width":"20rem"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'proximos' }}},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner.proximos),expression:"spinner.proximos"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" Próximos")]),_vm._v(" "),_vm._l((_vm.proximos.checks),function(proximo,index){return _c('div',{key:'pr-'+index,staticClass:"row pb-2"},[_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('strong',[_vm._v(_vm._s(proximo.days))]),_vm._v(" "),(proximo.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(proximo.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"8"}},[_c('span',[_vm._v("\n                          "+_vm._s(proximo.nm_check)+"\n                        ")]),_vm._v(" "),_c('h4',[_vm._v("\n                          "+_vm._s(proximo.nm_store)+"\n                        ")])]),_vm._v(" "),_c('b-col',{staticClass:"p-1",attrs:{"cols":"2"}},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: proximo.id_store, check: proximo.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1)],1)],1)})],2)])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8cfc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9w19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checks_vue__ = __webpack_require__("5zZZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a6e34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checks_vue__ = __webpack_require__("U6g3");
function injectStyle (ssrContext) {
  __webpack_require__("8cfc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01a6e34c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a6e34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AllU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      spinner: true,
      back: false,
      score: {},
      mainProps: { blank: true, width: 100, height: 100, class: 'm1' }
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    // Verifica se está definida a informação da loja.
    if (this.$route.params.store) {
      // Armazenando a loja e o check no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store);
      localStorage.setItem('id_check', this.$route.params.check);
      // Consumindo o WS.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/history/' + this.$route.params.store + '/' + this.$route.params.check).then(function (response) {
        _this.spinner = false;
        _this.back = true;
        _this.score = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    }
    // Parâmetros não definidos na rota (provavelmente um reload).
    else {
        // Verifica se existe a última loja visitada no localStorage.
        if (localStorage.getItem('id_store') && localStorage.getItem('id_check')) {
          // Consumindo o WS com a loja e o check armazenada no localStorage.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/history/' + localStorage.getItem('id_store') + '/' + localStorage.getItem('id_check')).then(function (response) {
            _this.spinner = false;
            _this.back = true;
            _this.score = response.data;
          });
        } else {
          this.backButton();
        }
      }
  },

  methods: {
    backButton: function backButton() {
      this.$router.go(-1);
    },
    updateComponent: function updateComponent() {
      var self = this;
      self.show = false;
      Vue.nextTick(function () {
        self.show = true;
      });
    },
    deleteResult: function deleteResult(idResult) {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
        title: 'Você tem certeza?',
        text: "Você não poderá reverter isso!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then(function (result) {
        if (result.value) {
          // Requisição para deltar o check.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/checks/deletar', { id_result: idResult }).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire('Excluído!', '', 'success').then(function (result) {
              if (result.value) {
                location.reload();
              }
            });
          });
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    }
  }
});

/***/ }),

/***/ "AqTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      stores: JSON.parse(localStorage.getItem('stores')),
      spinner: true,
      ranking: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.getItem('level') == 'supervisor') {
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/geral').then(function (response) {
        _this.spinner = false;_this.ranking = response.data;
      });
    }

    if (localStorage.getItem('level') == 'store') {
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/geral/'.this.$route.params.store).then(function (response) {
        _this.spinner = false;_this.ranking = response.data;
      });
    }
  }
});

/***/ }),

/***/ "CcPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"8"}},[_c('b-img',{staticStyle:{"width":"100%","max-width":"300px"},attrs:{"src":"http://api.checkpoint.recco.com.br/image_recco/recco.png","fluid":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"10"}},[_c('div',{staticClass:"card text-white mt-4",staticStyle:{"background":"#D30556"}},[_c('div',{staticClass:"card-header"},[_vm._v("Redefinir Senha")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-form',{attrs:{"autocomplete":"off"},on:{"submit":_vm.onSubmit}},[_c('b-form-group',[_c('b-form-input',{attrs:{"type":"password","required":"","placeholder":"Nova Senha"},model:{value:(_vm.passwordNew),callback:function ($$v) {_vm.passwordNew=$$v},expression:"passwordNew"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"password","required":"","placeholder":"Confirmar Senha"},model:{value:(_vm.passwordCheck),callback:function ($$v) {_vm.passwordCheck=$$v},expression:"passwordCheck"}})],1),_vm._v(" "),_c('b-button',{staticStyle:{"background":"#870337","border":"none"},attrs:{"type":"submit"}},[_vm._v("Salvar")])],1)],1)])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
    data: function data() {
        return {
            level: localStorage.getItem('level'),
            admin: localStorage.getItem('admin'),
            spinner: {
                ranking: true,
                atrasados: true,
                abertos: true,
                proximos: true
            },
            store: 'all',
            stores: [],
            ranking: [],
            atrasados: [],
            abertos: [],
            proximos: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/own').then(function (response) {
            _this.stores = response.data;
        });
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/geral').then(function (response) {
            _this.spinner.ranking = false;_this.ranking = response.data;
        });
        // Verifica se existe a loja global selecionada.
        if (localStorage.getItem('global-store')) {
            this.store = localStorage.getItem('global-store');
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/atrasados/' + this.store + '/4').then(function (response) {
                _this.spinner.atrasados = false;_this.atrasados = response.data;
            });
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/abertos/' + this.admin + '/' + this.store + '/4').then(function (response) {
                _this.spinner.abertos = false;_this.abertos = response.data;
            });
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/proximos/' + this.store + '/date/4').then(function (response) {
                _this.spinner.proximos = false;_this.proximos = response.data;
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/atrasados/all/4').then(function (response) {
                _this.spinner.atrasados = false;_this.atrasados = response.data;
            });
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/abertos/' + this.admin + '/all/4').then(function (response) {
                _this.spinner.abertos = false;_this.abertos = response.data;
            });
            __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/proximos/all/date/4').then(function (response) {
                _this.spinner.proximos = false;_this.proximos = response.data;
            });
        }
    },

    methods: {
        setStore: function setStore() {
            localStorage.setItem('global-store', this.store);
            location.reload();
        },
        logout: function logout() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                title: 'Sair do sistema?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DC3545',
                cancelButtonColor: '#DCDCDC',
                confirmButtonText: 'Sair',
                cancelButtonText: 'Cancelar'
            }).then(function (result) {
                if (result.value) {
                    // Limpando o localstorage.
                    localStorage.clear();
                    // Redireciona para login.
                    _this2.$router.push('login');
                }
            });
        }
    }
});

/***/ }),

/***/ "G+K8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__ = __webpack_require__("pbl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c245dd6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__ = __webpack_require__("CcPt");
function injectStyle (ssrContext) {
  __webpack_require__("xgOa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c245dd6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c245dd6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HnBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novaLoja: { nome: null, usuario: null },
      editarLoja: { id: null, status: null, nome: null, usuario: null, iniAval: null, iniFerias: null, fimFerias: null },
      users: [],
      models: [],
      stores: [],
      txt: '',
      listFerias: []
    };
  },
  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
    if (localStorage.getItem('admin') == 'false') this.$router.push('home');
  },
  mounted: function mounted() {
    this.up();
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
    },
    newStore: function newStore(evt) {
      var _this = this;

      evt.preventDefault();
      if (!this.novaLoja.nome || !this.novaLoja.usuario || !this.novaLoja.modelo) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: "error",
          title: 'Erro...',
          text: 'Informe o nome, usuário e modelo da loja de acesso.',
          dangerMode: true
        });
      } else {
        // Requisição para gravar a nova loja.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/store/save', {
          nome: this.novaLoja.nome,
          usuario: this.novaLoja.usuario,
          modelo: this.novaLoja.modelo
        }).then(function (response) {
          _this.clearData();
          _this.$refs.modalNew.hide();
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Ok!',
            text: 'Nova loja cadastrada.'
          });
          _this.up();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      }
    },
    editStore: function editStore(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (!this.editarLoja.nome || !this.editarLoja.usuario || !this.editarLoja.modelo) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Preencha as informações corretamente.',
          dangerMode: true
        });
      } else {
        var json = {
          id: this.editarLoja.id,
          status: this.editarLoja.status,
          nome: this.editarLoja.nome,
          usuario: this.editarLoja.usuario,
          modelo: this.editarLoja.modelo,
          iniAval: this.editarLoja.iniAval,
          iniFerias: this.editarLoja.iniFerias,
          fimFerias: this.editarLoja.fimFerias
        };
        // Requisição para gravar as alterações.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/store/update', json).then(function (response) {
          _this2.clearData();
          _this2.$refs.modalEdit.hide();
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Salvo!',
            text: 'Informações gravadas com sucesso!'
          });
          _this2.up();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      }
    },
    changeStatus: function changeStatus(store) {
      var _this3 = this;

      if (store.st_store == 1) {
        store.st_store = 0;
        this.txt = 'inativado';
      } else {
        store.st_store = 1;
        this.txt = 'Ativado';
      }

      var json = {
        id: store.id_store,
        status: store.st_store,
        nome: store.nm_store,
        usuario: store.id_user,
        modelo: store.id_model
      };
      // Requisição para inativar a loja.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/store/update', json).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'success',
          title: 'Salvo!',
          text: 'Loja ' + _this3.txt + '.'
        });
        _this3.up();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    iniAvaliacao: function iniAvaliacao(evt) {
      var _this4 = this;

      evt.preventDefault();

      if (this.editarLoja.iniAval == null || this.editarLoja.iniAval == "") {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Existe uma inconsistência!',
          text: 'Preencha o campo "Início".'
        });
      } else {
        var date1 = new Date();
        var date2 = new Date(this.editarLoja.iniAval + " 23:59:00");

        if (date1.getTime() < date2.getTime()) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'error',
            title: 'Existe uma inconsistência!',
            text: 'O "Início" não pode ser maior que a data atual.'
          });
        } else {
          var json = {
            id: this.editarLoja.id,
            nome: this.editarLoja.nome,
            dateStart: this.editarLoja.iniAval
          };
          // Requisição para inativar a loja.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/store/setAssessment', json).then(function (response) {
            _this4.clearData();
            _this4.$refs.modalEditAvalInicio.hide();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              icon: 'success',
              title: 'Período de Avaliação Atualizado!',
              text: 'Informações atualizadas com sucesso!'
            });
            _this4.up();
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            });
          });
        }
      }
    },
    setFerias: function setFerias(evt) {
      var _this5 = this;

      evt.preventDefault();
      //console.log(this.editarLoja);

      if (this.editarLoja.iniFerias == null || this.editarLoja.fimFerias == null || this.editarLoja.iniFerias > this.editarLoja.fimFerias) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Existe uma inconsistência!',
          text: 'Por favor, preencha todos os campos corretamente.',
          dangerMode: true
        });
      } else {
        var json = {
          id: this.editarLoja.id,
          nome: this.editarLoja.nome,
          dateStart: this.editarLoja.iniFerias,
          dateEnd: this.editarLoja.fimFerias
        };
        // Requisição para inativar a loja.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/store/setHoliday', json).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Período de Férias Cadastrado!',
            text: 'Informações atualizadas com sucesso!'
          });
          _this5.editarLoja.iniFerias = null;
          _this5.editarLoja.fimFerias = null;
          _this5.listFerias = null;

          _this5.getListFerias();
          _this5.up();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      }
    },
    getListFerias: function getListFerias() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/holiday/' + this.editarLoja.id).then(function (response) {
        _this6.listFerias = [];
        response.data.forEach(function (ferias) {
          _this6.listFerias.push({ id: ferias.id_results_aux, desc: ferias.nm_results_aux });
        });
        _this6.up();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    deleteFerias: function deleteFerias(id) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].delete('/store/holiday/' + id).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'success',
          title: 'Período de Férias Removido!',
          text: 'Informações atualizadas com sucesso!'
        });
        _this7.getListFerias();
        _this7.up();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    getInicioAvaliacao: function getInicioAvaliacao() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/assessment/' + this.editarLoja.id).then(function (response) {
        _this8.editarLoja.iniAval = response.data.dt_start;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    setStore: function setStore(store) {
      this.editarLoja.id = store.id_store;
      this.editarLoja.status = store.st_store;
      this.editarLoja.nome = store.nm_store;
      this.editarLoja.usuario = store.id_user;
      this.editarLoja.modelo = store.id_model;
    },
    clearData: function clearData(evt) {
      this.novaLoja.id = null;
      this.novaLoja.status = null;
      this.novaLoja.nome = null;
      this.novaLoja.usuario = null;
      this.editarLoja.id = null;
      this.editarLoja.status = null;
      this.editarLoja.nome = null;
      this.editarLoja.usuario = null;
      this.editarLoja.modelo = null;
      this.editarLoja.iniAval = null;
      this.editarLoja.iniFerias = null;
      this.editarLoja.fimFerias = null;
      this.listFerias = null;
    },
    up: function up() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/all/store').then(function (response) {
        _this9.stores = response.data;
      });
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/stores').then(function (response) {
        _this9.users = response.data;
      });
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/model/all').then(function (response) {
        _this9.models = response.data;
      });
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {}
}));

/***/ }),

/***/ "J/wO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"cols":"8"}},[_c('b-img',{staticStyle:{"width":"100%","max-width":"300px"},attrs:{"src":"http://api.checkpoint.recco.com.br/image_recco/recco.png","fluid":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"10"}},[_c('div',{staticClass:"card text-white mt-4",staticStyle:{"background":"#D30556"}},[_c('div',{staticClass:"card-header"},[_vm._v("CheckPoint")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',[_c('b-form-input',{attrs:{"type":"email","required":"","placeholder":"E-mail"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"password","required":"","placeholder":"Senha"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('div',{staticClass:"text-sm-right"},[_c('b-link',{attrs:{"href":"#"},on:{"click":function($event){return _vm.redefinirSenha()}}},[_vm._v("Redefinir Senha.")])],1)],1),_vm._v(" "),_c('b-button',{staticStyle:{"background":"#870337","border":"none"},attrs:{"type":"submit"}},[_vm._v("Entrar")])],1)],1)])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JbDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proximos_vue__ = __webpack_require__("Xfzh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca3260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proximos_vue__ = __webpack_require__("nk/7");
function injectStyle (ssrContext) {
  __webpack_require__("OZk1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93ca3260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proximos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca3260_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proximos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KHCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-danger text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_vm._v(_vm._s(_vm.atrasados.size))],1),_vm._v(" "),_c('h4',[_vm._v("Atrasados")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"row pb-4"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store),expression:"store"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.store=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setStore()}]}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todas as Lojas")]),_vm._v(" "),_vm._l((_vm.stores),function(store,index){return _c('option',{key:'store-'+index,domProps:{"value":store.id_store}},[_vm._v(_vm._s(store.nm_store))])})],2)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.atrasados.checks),function(atrasado,index){return _c('div',{key:'a'+index,staticClass:"row mt-2"},[_c('div',{staticClass:"col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(atrasado.days))]),_vm._v(" "),(atrasado.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(atrasado.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-6 col-lg-4"},[_c('span',[_vm._v(_vm._s(atrasado.nm_check))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(atrasado.nm_store))])]),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1 col-lg-1 text-center"},[(_vm.level == 'supervisor')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'atrasado', store: atrasado.id_store, check: atrasado.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: atrasado.id_store, check: atrasado.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1):_vm._e()],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M84A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-info text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('b-link',{staticClass:"text-white",on:{"click":function($event){return _vm.backButton()}}},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.back),expression:"back"}],attrs:{"name":"arrow-circle-left","scale":"2.5"}})],1)]),_c('h4',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.score.nm_store))])],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"m-0 p-0"},[_vm._v("ITEM")]),_c('h4',[_vm._v(_vm._s(_vm.score.nm_check))])])]),_vm._v(" "),_c('div',{staticClass:"row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"m-0 p-0"},[_vm._v("GRUPO")]),_c('h4',[_vm._v(_vm._s(_vm.score.nm_group))])])]),_vm._v(" "),_c('div',{staticClass:"row m-0 mb-1 pt-2 pb-2 pl-0 pr-0"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"m-0 p-0 text-white",domProps:{"innerHTML":_vm._s(_vm.score.ds_check.replace(/(?:\r\n|\r|\n)/g, '<br />'))}})])]),_vm._v(" "),_c('div',{staticClass:"row dark-background m-0 mb-1 pt-2 pb-2 pl-0 pr-0"},[_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"m-0 p-0 text-white"},[_vm._v("Frequência: "+_vm._s(_vm.score.nr_freq))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"m-0 p-0 text-white"},[_vm._v("Peso: "+_vm._s(_vm.score.nr_factor))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"role":"tablist"}},_vm._l((_vm.score.results),function(result,index){return _c('div',{key:'r'+result.id_result,staticClass:"m-0"},[_c('b-row',{staticClass:"p-0 m-0",attrs:{"role":"tab"}},[_c('b-col',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('t-'+index),expression:"'t-'+index"}],staticClass:"dark-background m-0 mb-1 p-2",attrs:{"cols":"6"}},[_c('h6',{staticClass:"p-0 m-0"},[_vm._v(_vm._s(result.dt_result))])]),_vm._v(" "),_c('b-col',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('t-'+index),expression:"'t-'+index"}],staticClass:"dark-background m-0 mb-1 p-2 text-right",attrs:{"cols":"5"}},[(result.vl_result == 0)?_c('strong',[_vm._v("Ok")]):_vm._e(),_vm._v(" "),(result.vl_result == 1)?_c('strong',[_vm._v("-"+_vm._s(_vm.score.nr_factor))]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"dark-background delete m-0 ml-1 mb-1 p-0 p-0 pt-2 text-center"},[(index == 0)?_c('b-link',{staticClass:"text-white",attrs:{"s":""},on:{"click":function($event){return _vm.deleteResult(result.id_result)}}},[_c('icon',{attrs:{"name":"trash","scale":"1"}})],1):_vm._e(),_vm._v(" "),(index > 0)?_c('span',{staticClass:"text-white",attrs:{"s":""}},[_c('icon',{attrs:{"name":"window-minimize","scale":"1"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-collapse',{staticClass:"mensagens",attrs:{"id":'t-'+index,"accordion":"results","role":"tabpanel"}},[_c('ul',{staticClass:"p-2 m-0 mb-2"},[(result.messages == '')?_c('li',[_vm._v("Sem mensagens.")]):_vm._e(),_vm._v(" "),_vm._l((result.messages),function(message,index){return _c('li',{key:'m'+index},[_c('small',[_vm._v(_vm._s(message.dt_message)),_c('br'),_vm._v(" "+_vm._s(message.nm_sender))]),_vm._v(" "),(message.tp_message == 'txt')?_c('span',[_vm._v(_vm._s(message.ds_message))]):_vm._e(),_vm._v(" "),(message.tp_message == 'img')?_c('span',{staticClass:"p-0 m-0"},[_c('img',_vm._b({staticClass:"img-fluid",attrs:{"src":message.ds_message}},'img',_vm.mainProps,false))]):_vm._e()])})],2)])],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"text-info-h4"},[_vm._v("Últimas Avaliações")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc7bf6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("tnWa");
function injectStyle (ssrContext) {
  __webpack_require__("peZ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc7bf6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http__ = __webpack_require__("0zyd");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// Rotina para validação de acesso na determinada rota.
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.jwt;
  })) {
    if (localStorage.getItem('token')) {
      // Definindo o token no headers no caso de um refresh no navegador.
      __WEBPACK_IMPORTED_MODULE_8__http__["a" /* http */].defaults.headers.common['Authorization'] = localStorage.getItem('token');
    } else {
      next({ path: '/' });
    }
  }
  next();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OZk1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PYWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-info text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" "),_c('h4',[_vm._v("Ranking")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_vm._l((_vm.ranking.stores),function(store,index){return _c('div',{key:'s'+index,staticClass:"row mt-2 no-gutters",attrs:{"id":'store-'+index}},[(store.access == true)?[_c('div',{staticClass:"col-7 col-sm-6 col-md-4 col-lg-2 col-xl-2 offset-md-2 offset-lg-3 offset-xl-3 pt-2"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'score', params: { store: store.id_store }}}},[_vm._v(_vm._s(store.ranking)+"º "+_vm._s(store.nm_store))])],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-5 col-md-3 col-lg-3 col-xl-3 offset-xl-0"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'score', params: { store: store.id_store }}}},[_c('b-progress',{attrs:{"show-value":"","height":"34px","variant":"warning","precision":1,"value":store.sc_store}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-1 col-sm-1 col-md-1 col-lg-1 pl-2"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'score', params: { store: store.id_store }}}},[_c('icon',{attrs:{"name":"caret-right","scale":"1.8"}})],1)],1)]:[_c('div',{staticClass:"col-7 col-sm-6 col-md-4 col-lg-2 col-xl-2 offset-md-2 offset-lg-3 offset-xl-3 pt-2"},[_vm._v(_vm._s(store.ranking)+"º "+_vm._s(store.nm_store))]),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-5 col-md-3 col-lg-3 col-xl-3 offset-xl-0"},[_c('b-progress',{attrs:{"show-value":"","height":"34px","variant":"warning","precision":1,"value":store.sc_store}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 col-sm-1 col-md-1 col-lg-1"})]],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PwEo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      checklist: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/own').then(function (response) {
      _this.stores = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/proximos/' + localStorage.getItem('global-store') + '/checklist').then(function (response) {
      _this.spinner = false;_this.checklist = response.data;
    });
  },

  methods: {
    setStore: function setStore() {
      localStorage.setItem('global-store', this.store);
      location.reload();
    }
  }
});

/***/ }),

/***/ "QG5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Score_vue__ = __webpack_require__("c52X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b627588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Score_vue__ = __webpack_require__("dla8");
function injectStyle (ssrContext) {
  __webpack_require__("n9NO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b627588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Score_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b627588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Score_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SY18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("dxC/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca93f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("rPy2");
function injectStyle (ssrContext) {
  __webpack_require__("2xEN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aca93f4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca93f4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U6g3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-light"},[_c('div',{staticClass:"row title-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-dark",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.novoCheck",modifiers:{"novoCheck":true}}],attrs:{"variant":"success"}},[_vm._v("Novo Check")])],1)]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('table',{staticClass:"table table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.checks),function(check,index){return _c('tr',{key:'check-'+index},[_c('td',{staticClass:"align-middle text-truncate"},[_vm._v(_vm._s(check.nm_check))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-toolbar float-right",attrs:{"role":"toolbar"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.editarCheck",modifiers:{"editarCheck":true}}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.setCheck(check)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"pencil","scale":"1.2"}})],1),_vm._v(" "),(check.st_check == '1')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-success",attrs:{"title":"Desativar"},on:{"click":function($event){return _vm.changeStatus(check)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"check","scale":"1.2"}})],1):_vm._e(),_vm._v(" "),(check.st_check == '0')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger",attrs:{"title":"Ativar"},on:{"click":function($event){return _vm.changeStatus(check)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"ban","scale":"1.2"}})],1):_vm._e()],1)])])])}),0)])])]),_vm._v(" "),_c('b-modal',{ref:"modalNew",attrs:{"id":"novoCheck","title":"Novo Check","no-close-on-backdrop":""},on:{"ok":_vm.newCheck,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"grupo"}},[_vm._v("Grupo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoCheck.grupo),expression:"novoCheck.grupo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novoCheck, "grupo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.groups),function(group,index){return _c('option',{key:'group-'+index,domProps:{"value":group.id_group}},[_vm._v(_vm._s(group.nm_group))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"modelo"}},[_vm._v("Modelo de Check")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoCheck.modelo),expression:"novoCheck.modelo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novoCheck, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.models),function(model,index){return _c('option',{key:'model-'+index,domProps:{"value":model.id_model}},[_vm._v(_vm._s(model.nm_model))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeCheck"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoCheck.nome),expression:"novoCheck.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nomeCheck","required":""},domProps:{"value":(_vm.novoCheck.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novoCheck, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"descCheck"}},[_vm._v("Descrição")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoCheck.descricao),expression:"novoCheck.descricao"}],staticClass:"form-control",attrs:{"id":"descCheck","rows":"3","maxlength":"1000","required":""},domProps:{"value":(_vm.novoCheck.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novoCheck, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"freqCheck"}},[_vm._v("Frequência (dias)")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['###', '##'],"id":"freqCheck","required":""},model:{value:(_vm.novoCheck.frequencia),callback:function ($$v) {_vm.$set(_vm.novoCheck, "frequencia", $$v)},expression:"novoCheck.frequencia"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"pesoCheck"}},[_vm._v("Peso")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['###.##', '##.##', '#.##'],"masked":"true","id":"pesoCheck","required":""},model:{value:(_vm.novoCheck.peso),callback:function ($$v) {_vm.$set(_vm.novoCheck, "peso", $$v)},expression:"novoCheck.peso"}})],1)])])]),_vm._v(" "),_c('b-modal',{ref:"modalEdit",attrs:{"id":"editarCheck","title":"Editar Check","no-close-on-backdrop":""},on:{"ok":_vm.editCheck,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"grupo"}},[_vm._v("Grupo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarCheck.grupo),expression:"editarCheck.grupo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarCheck, "grupo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.groups),function(group,index){return _c('option',{key:'group-'+index,domProps:{"value":group.id_group}},[_vm._v(_vm._s(group.nm_group))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"modelo"}},[_vm._v("Modelo de Check")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarCheck.modelo),expression:"editarCheck.modelo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarCheck, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.models),function(model,index){return _c('option',{key:'model-'+index,domProps:{"value":model.id_model}},[_vm._v(_vm._s(model.nm_model))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeCheck"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarCheck.nome),expression:"editarCheck.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nomeCheck","required":""},domProps:{"value":(_vm.editarCheck.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarCheck, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"descCheck"}},[_vm._v("Descrição")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarCheck.descricao),expression:"editarCheck.descricao"}],staticClass:"form-control",attrs:{"id":"descCheck","rows":"3","maxlength":"1000","required":""},domProps:{"value":(_vm.editarCheck.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarCheck, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"freqCheck"}},[_vm._v("Frequência (dias)")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['###', '##'],"id":"freqCheck","required":""},model:{value:(_vm.editarCheck.frequencia),callback:function ($$v) {_vm.$set(_vm.editarCheck, "frequencia", $$v)},expression:"editarCheck.frequencia"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"pesoCheck"}},[_vm._v("Peso")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":['###.##', '##.##', '#.##'],"type":"tel","id":"pesoCheck","required":""},model:{value:(_vm.editarCheck.peso),callback:function ($$v) {_vm.$set(_vm.editarCheck, "peso", $$v)},expression:"editarCheck.peso"}})],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 text-left text-dark"},[_c('h4',[_vm._v("Cadastro de Checks")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Nome")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Opções")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjiQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__ = __webpack_require__("HnBO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1b09892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__ = __webpack_require__("d5YJ");
function injectStyle (ssrContext) {
  __webpack_require__("YsPC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1b09892"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1b09892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xfzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      proximos: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/own').then(function (response) {
      _this.stores = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/proximos/' + localStorage.getItem('global-store') + '/date').then(function (response) {
      _this.spinner = false;_this.proximos = response.data;
    });
  },

  methods: {
    setStore: function setStore() {
      localStorage.setItem('global-store', this.store);
      location.reload();
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Password__ = __webpack_require__("G+K8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ranking__ = __webpack_require__("wc4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Score__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_History__ = __webpack_require__("yZHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Atrasados__ = __webpack_require__("tQ77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Abertos__ = __webpack_require__("bZ4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Proximos__ = __webpack_require__("JbDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Checklist__ = __webpack_require__("sPvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Check__ = __webpack_require__("+7QF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Store__ = __webpack_require__("UjiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Users__ = __webpack_require__("TKn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Checks__ = __webpack_require__("9w19");

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '*', redirect: '/' }, { path: '/', name: 'login', component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */] }, { path: '/password/:hash', name: 'password', component: __WEBPACK_IMPORTED_MODULE_3__components_Password__["a" /* default */] }, { path: '/home', name: 'home', component: __WEBPACK_IMPORTED_MODULE_4__components_Home__["a" /* default */], meta: { jwt: true } }, { path: '/ranking', name: 'ranking', component: __WEBPACK_IMPORTED_MODULE_5__components_Ranking__["a" /* default */], props: true, meta: { jwt: true } }, { path: '/score', name: 'score', component: __WEBPACK_IMPORTED_MODULE_6__components_Score__["a" /* default */], props: true, meta: { jwt: true } }, { path: '/history', name: 'history', component: __WEBPACK_IMPORTED_MODULE_7__components_History__["a" /* default */], props: true, meta: { jwt: true } }, { path: '/atrasados', name: 'atrasados', component: __WEBPACK_IMPORTED_MODULE_8__components_Atrasados__["a" /* default */], meta: { jwt: true } }, { path: '/abertos', name: 'abertos', component: __WEBPACK_IMPORTED_MODULE_9__components_Abertos__["a" /* default */], meta: { jwt: true } }, { path: '/proximos', name: 'proximos', component: __WEBPACK_IMPORTED_MODULE_10__components_Proximos__["a" /* default */], meta: { jwt: true } }, { path: '/checklist', name: 'checklist', component: __WEBPACK_IMPORTED_MODULE_11__components_Checklist__["a" /* default */], meta: { jwt: true } }, { path: '/check', name: 'check', component: __WEBPACK_IMPORTED_MODULE_12__components_Check__["a" /* default */], props: true, meta: { jwt: true } }, { path: '/stores', name: 'stores', component: __WEBPACK_IMPORTED_MODULE_13__components_Store__["a" /* default */], meta: { jwt: true } }, { path: '/users', name: 'users', component: __WEBPACK_IMPORTED_MODULE_14__components_Users__["a" /* default */], meta: { jwt: true } }, { path: '/checks', name: 'checks', component: __WEBPACK_IMPORTED_MODULE_15__components_Checks__["a" /* default */], meta: { jwt: true } }]
}));

/***/ }),

/***/ "YsPC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bZ4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Abertos_vue__ = __webpack_require__("fTzI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69eff7dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Abertos_vue__ = __webpack_require__("f7aM");
function injectStyle (ssrContext) {
  __webpack_require__("yaX4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69eff7dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Abertos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69eff7dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Abertos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c52X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      back: false,
      score: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    // Verifica se está definida a informação da loja.
    if (this.$route.params.store) {
      // Armazenando a loja no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store);
      // Consumindo o WS.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/score/' + this.$route.params.store).then(function (response) {
        _this.spinner = false;_this.back = true;_this.score = response.data;
      });
    }
    // Parâmetros não definidos na rota.
    else {
        // Verifica se existe a última loja visitada no localStorage.
        if (localStorage.getItem('id_store')) {
          // Consumindo o WS com a loja armazenada no localStorage.
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/ranking/score/' + localStorage.getItem('id_store')).then(function (response) {
            _this.spinner = false;_this.back = true;_this.score = response.data;
          });
        } else {
          this.$router.go(-1);
        }
      }
  }
});

/***/ }),

/***/ "d5YJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-light"},[_c('div',{staticClass:"row title-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-dark",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.novaLoja",modifiers:{"novaLoja":true}}],attrs:{"variant":"success"}},[_vm._v("Nova Loja")])],1)]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('table',{staticClass:"table table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.stores),function(store,index){return _c('tr',{key:'store-'+index},[_c('td',{staticClass:"align-middle"},[_vm._v(_vm._s(store.nm_store))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btn-toolbar float-right",attrs:{"role":"toolbar"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.editarLoja",modifiers:{"editarLoja":true}}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.setStore(store)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"pencil","scale":"1.2"}})],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.editAvalInicio",modifiers:{"editAvalInicio":true}}],attrs:{"variant":"warning text-white"},on:{"click":function($event){return _vm.setStore(store)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"hourglass","scale":"1.2"}})],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.editAvalFerias",modifiers:{"editAvalFerias":true}}],attrs:{"variant":"info"},on:{"click":function($event){return _vm.setStore(store)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"clipboard","scale":"1.2"}})],1),_vm._v(" "),(store.st_store == '1')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-success",attrs:{"title":"Desativar"},on:{"click":function($event){return _vm.changeStatus(store)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"check","scale":"1.2"}})],1):_vm._e(),_vm._v(" "),(store.st_store == '0')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger",attrs:{"title":"Ativar"},on:{"click":function($event){return _vm.changeStatus(store)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"ban","scale":"1.2"}})],1):_vm._e()],1)])])])}),0)])])]),_vm._v(" "),_c('b-modal',{ref:"modalNew",attrs:{"id":"novaLoja","title":"Nova Loja","no-close-on-backdrop":""},on:{"ok":_vm.newStore,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeLoja"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novaLoja.nome),expression:"novaLoja.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nomeLoja","required":""},domProps:{"value":(_vm.novaLoja.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novaLoja, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeLoja"}},[_vm._v("Usuário da Loja")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novaLoja.usuario),expression:"novaLoja.usuario"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novaLoja, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.users),function(user,index){return (user.stores == '0')?_c('option',{key:'users-'+index,domProps:{"value":user.id_user}},[_vm._v(_vm._s(user.nm_user)+"\n          ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeModelo"}},[_vm._v("Modelo de Check")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novaLoja.modelo),expression:"novaLoja.modelo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novaLoja, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.models),function(model,index){return _c('option',{key:'model-'+index,domProps:{"value":model.id_model}},[_vm._v("\n            "+_vm._s(model.nm_model)+"\n          ")])}),0)])])]),_vm._v(" "),_c('b-modal',{ref:"modalEdit",attrs:{"id":"editarLoja","title":"Editar Loja","no-close-on-backdrop":""},on:{"ok":_vm.editStore,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeLoja"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.nome),expression:"editarLoja.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nomeLoja","required":""},domProps:{"value":(_vm.editarLoja.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarLoja, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeLoja"}},[_vm._v("Usuário da Loja")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.usuario),expression:"editarLoja.usuario"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarLoja, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.users),function(user,index){return (user.id_user == _vm.editarLoja.usuario || user.stores == 0)?_c('option',{key:'user-'+index,domProps:{"value":user.id_user}},[_vm._v("\n            "+_vm._s(user.nm_user)+"\n          ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeModelo"}},[_vm._v("Modelo de Check")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.modelo),expression:"editarLoja.modelo"}],staticClass:"custom-select",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarLoja, "modelo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.models),function(model,index){return _c('option',{key:'model-'+index,domProps:{"value":model.id_model}},[_vm._v("\n            "+_vm._s(model.nm_model)+"\n          ")])}),0)])])]),_vm._v(" "),(_vm.level == 'supervisor')?_c('b-modal',{ref:"modalEditAvalFerias",attrs:{"id":"editAvalFerias","title":"Período de Férias","no-close-on-backdrop":""},on:{"ok":_vm.setFerias,"shown":_vm.getListFerias,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"iniFerias"}},[_vm._v("Início")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.iniFerias),expression:"editarLoja.iniFerias"}],staticClass:"form-control",attrs:{"type":"date","id":"iniFerias"},domProps:{"value":(_vm.editarLoja.iniFerias)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarLoja, "iniFerias", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"fimFerias"}},[_vm._v("Fim")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.fimFerias),expression:"editarLoja.fimFerias"}],staticClass:"form-control",attrs:{"type":"date","id":"fimFerias"},domProps:{"value":(_vm.editarLoja.fimFerias)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarLoja, "fimFerias", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12"},[_c('h4',{staticClass:"text-info-h1"},[_vm._v("Histórico")])])]),_vm._v(" "),_vm._l((_vm.listFerias),function(list,index){return (index < 10)?_c('div',{key:'r-'+index,staticClass:"row pt-1 pb-1"},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"6"}},[_vm._v("\n          "+_vm._s(list.desc)+"\n          "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Fechar"},on:{"click":function($event){return _vm.deleteFerias(list.id)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],1):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.level == 'supervisor')?_c('b-modal',{ref:"modalEditAvalInicio",attrs:{"id":"editAvalInicio","title":"Período de Avaliação","no-close-on-backdrop":""},on:{"ok":_vm.iniAvaliacao,"shown":_vm.getInicioAvaliacao,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"iniAval"}},[_vm._v("Início")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarLoja.iniAval),expression:"editarLoja.iniAval"}],staticClass:"form-control",attrs:{"type":"date","id":"iniAval"},domProps:{"value":(_vm.editarLoja.iniAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarLoja, "iniAval", $event.target.value)}}})])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 text-left text-dark"},[_c('h4',[_vm._v("Cadastro de Loja")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Nome")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Opções")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dla8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-info text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10"},[(_vm.level == 'supervisor')?_c('b-link',{attrs:{"to":{ name: 'ranking' }}},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.back),expression:"back"}],attrs:{"name":"arrow-circle-left","scale":"2.5"}})],1),_c('h4',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.score.nm_store))])]):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('b-link',{attrs:{"to":{ name: 'home' }}},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.back),expression:"back"}],attrs:{"name":"arrow-circle-left","scale":"2.5"}})],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row score"},[_c('div',{staticClass:"col-6 col-md-5 col-lg-4 col-xl-4 offset-md-1 offset-lg-2 offset-xl-2"},[_c('span',[_vm._v(_vm._s(_vm.score.ranking)+"º")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-5 col-lg-4 col-xl-4"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.score.score))]),_vm._v(" Score")])])]),_vm._v(" "),_vm._l((_vm.score.groups),function(group,index){return (group.view == 'S')?[_c('div',{key:'g'+index,staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-7 offset-md-1 offset-lg-2 offset-xl-3"},[_c('h5',[_vm._v(_vm._s(group.nm_group))])])]),_vm._v(" "),_vm._l((group.checks),function(check){return _c('div',{key:check.id_check,staticClass:"row mt-2"},[_c('div',{staticClass:"col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_vm._v(_vm._s(check.score))]),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-6 col-lg-4"},[_vm._v(_vm._s(check.nm_check))]),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1 col-lg-1 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: _vm.score.id_store, check: check.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1)],1)])})]:_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novoUsuario: { nome: null, tipo: null, permissao: null, email: null, pass: null },
      editarUsuario: { user: null, nome: null, tipo: null, permissao: null, email: null, pass: null, active: null },
      permissoes: {
        usuario: null,
        selected: [],
        options: []
      },
      permissoesCheck: {
        usuario: null,
        selected: [],
        selectedAux: [],
        options: []
      },
      users: [],
      stores: [],
      txt: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      statusCheck_value: 'accepted',
      statusCheck_text: ''
    };
  },
  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
    if (localStorage.getItem('admin') == 'false') this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
      _this.users = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/all').then(function (response) {
      _this.stores = response.data;
    });
    this.setStatusCheck();
  },

  methods: {
    isEmailValid: function isEmailValid(email) {
      return email === "" ? false : this.reg.test(email) ? true : false;
    },
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
    },
    newUser: function newUser(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (!this.novoUsuario.nome) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um nome para o novo usuário.',
          dangerMode: true
        });
      } else if (!this.novoUsuario.tipo) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um tipo para o novo usuário.',
          dangerMode: true
        });
      } else if (this.isEmailValid(this.novoUsuario.email) === false) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um e-mail valido para o novo usuário.',
          dangerMode: true
        });
      } else if (!this.novoUsuario.pass) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe uma senha para o novo usuário.',
          dangerMode: true
        });
      } else {
        var jSON = {
          nome: this.novoUsuario.nome,
          tipo: this.novoUsuario.tipo,
          permissao: this.novoUsuario.tipo == 1 ? this.novoUsuario.permissao == 1 ? 1 : 0 : 0,
          email: this.novoUsuario.email,
          password: this.novoUsuario.pass
        };
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/user/save', jSON).then(function (response) {
          _this2.clearData();
          _this2.$refs.modalNew.hide();
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Ok!',
            text: 'Novo usuário cadastrado.'
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
            _this2.users = response.data;
          });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem,
            dangerMode: true
          });
        });
      }
    },
    editUser: function editUser(evt) {
      var _this3 = this;

      evt.preventDefault();
      if (!this.editarUsuario.nome) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um nome para o novo usuário.',
          dangerMode: true
        });
      } else if (this.isEmailValid(this.editarUsuario.email) === false) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Informe um e-mail valido para o novo usuário.',
          dangerMode: true
        });
      } else {
        var jSON = {
          id: this.editarUsuario.user,
          nome: this.editarUsuario.nome,
          tipo: this.editarUsuario.tipo,
          permissao: this.editarUsuario.tipo == 1 ? this.editarUsuario.permissao == 1 ? 1 : 0 : 0,
          email: this.editarUsuario.email,
          password: this.editarUsuario.pass,
          active: this.editarUsuario.active
          // Requisição para gravar as alterações.
        };__WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/user/update', jSON).then(function (response) {
          _this3.clearData();
          _this3.$refs.modalEdit.hide();
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Salvo!',
            text: 'Informações gravadas com sucesso!'
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
            _this3.users = response.data;
          });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem,
            dangerMode: true
          });
        });
      }
    },
    getPermissoesCheck: function getPermissoesCheck(user) {
      var _this4 = this;

      // Buscando as lojas que o supervisor tem permissão.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/permissoes/all/' + user.id_user).then(function (response) {
        _this4.permissoesCheck.usuario = user.id_user;
        response.data.forEach(function (check) {
          _this4.permissoesCheck.options.push({ text: check.nm_check, value: check.id_check });
          _this4.permissoesCheck.selectedAux.push(check.id_check);
          if (check.id_user != null) {
            _this4.permissoesCheck.selected.push(check.id_check);
          }
        });

        if (_this4.permissoesCheck.selected.length == 0) {
          _this4.permissoesCheck.selected = _this4.permissoesCheck.selectedAux;
        }

        if (_this4.permissoesCheck.selected.length == _this4.permissoesCheck.selectedAux.length) {
          _this4.statusCheck_value = 'accepted';
        } else {
          _this4.statusCheck_value = 'not_accepted';
        }

        _this4.setStatusCheck();
      });
    },
    savePermissoesCheck: function savePermissoesCheck(evt) {
      var _this5 = this;

      evt.preventDefault();

      if (this.permissoesCheck.selected.length == 0) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Nenhum item foi selecionado.',
          dangerMode: true
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/permissoes/save', { id_user: this.permissoesCheck.usuario, checks: this.permissoesCheck.selected }).then(function (response) {
          _this5.clearData();
          _this5.$refs.modalPermissoesCheck.hide();
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            icon: 'success',
            title: 'Ok!',
            text: 'Permissões gravadas.'
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
            _this5.users = response.data;
          });
          __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/all').then(function (response) {
            _this5.stores = response.data;
          });
        });
      }
    },
    getStores: function getStores(user) {
      var _this6 = this;

      // Buscando as lojas que o supervisor tem permissão.
      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/all/supervisor/' + user.id_user).then(function (response) {
        _this6.permissoes.usuario = user.id_user;
        response.data.forEach(function (store) {
          _this6.permissoes.selected.push(store.id_store);
        });
      });

      this.stores.forEach(function (e) {
        // Criando as opções no array de checkboxes.
        _this6.permissoes.options.push({ text: e.nm_store, value: e.id_store });

        // Verificando as lojas que o supervisor tem acesso para trazer selecionado no checkboxes.
        if (e.id_user == user.id_user) {
          _this6.permissoes.selected.push(e.id_store);
        }
      });
    },
    savePermissoes: function savePermissoes(evt) {
      var _this7 = this;

      evt.preventDefault();

      __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/user/permissoes', { id_user: this.permissoes.usuario, stores: this.permissoes.selected }).then(function (response) {
        _this7.clearData();
        _this7.$refs.modalStore.hide();
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'success',
          title: 'Ok!',
          text: 'Permissões gravadas.'
        });
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
          _this7.users = response.data;
        });
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/all').then(function (response) {
          _this7.stores = response.data;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    changeStatus: function changeStatus(user) {
      var _this8 = this;

      if (user.active == 1) {
        user.active = 0;
        this.txt = 'inativado';
      } else {
        user.active = 1;
        this.txt = 'Ativado';
      }

      var jSON = {
        id: user.id_user,
        nome: user.nm_user,
        tipo: user.st_user,
        permissao: user.ad_user,
        email: user.em_user,
        active: user.active

        // Requisição para inativar o usuário.
      };__WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/user/update', jSON).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          icon: 'success',
          title: 'Salvo!',
          text: 'Usuário ' + _this8.txt + '.'
        });
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/user/all').then(function (response) {
          _this8.users = response.data;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    setUser: function setUser(user) {
      this.editarUsuario.user = user.id_user;
      this.editarUsuario.nome = user.nm_user;
      this.editarUsuario.tipo = user.st_user;
      this.editarUsuario.permissao = user.ad_user;
      this.editarUsuario.email = user.em_user;
      this.editarUsuario.active = user.active;
    },
    clearData: function clearData(evt) {
      this.editarUsuario.user = null;
      this.editarUsuario.nome = null;
      this.editarUsuario.tipo = null;
      this.editarUsuario.permissao = null;
      this.editarUsuario.email = null;
      this.editarUsuario.active = null;
      this.novoUsuario.nome = null;
      this.novoUsuario.tipo = null;
      this.novoUsuario.permissao = null;
      this.novoUsuario.email = null;
      this.novoUsuario.pass = null;
      this.permissoes.usuario = null;
      this.permissoes.selected = [];
      this.permissoes.options = [];
      this.permissoesCheck.usuario = null;
      this.permissoesCheck.selected = [];
      this.permissoesCheck.options = [];
      this.permissoesCheck.selectedAux = [];
    },
    statusCheck: function statusCheck() {
      this.setStatusCheck();

      if (this.statusCheck_value == 'accepted') {
        this.permissoesCheck.selected = this.permissoesCheck.selectedAux;
      } else {
        this.permissoesCheck.selected = [];
      }
    },
    setStatusCheck: function setStatusCheck() {
      if (this.statusCheck_value == 'accepted') {
        this.statusCheck_text = 'Desmarcar todos';
      } else {
        this.statusCheck_text = 'Marcar todos';
      }
    }
  }
});

/***/ }),

/***/ "f7aM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-warning text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_vm._v(_vm._s(_vm.abertos.size))],1),_vm._v(" "),_c('h4',[_vm._v("Trabalhando")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"row pb-4"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store),expression:"store"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.store=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setStore()}]}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todas as Lojas")]),_vm._v(" "),_vm._l((_vm.stores),function(store,index){return _c('option',{key:'store-'+index,domProps:{"value":store.id_store}},[_vm._v(_vm._s(store.nm_store))])})],2)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.abertos.checks),function(aberto,index){return _c('div',{key:'abertos-'+index,staticClass:"row mt-2",attrs:{"id":'aberto-'+index}},[_c('div',{staticClass:"col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(aberto.days))]),_vm._v(" "),(aberto.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(aberto.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-6 col-lg-4"},[_c('span',[_vm._v(_vm._s(aberto.nm_check))]),_vm._v(" "),(aberto.new_post > 0)?_c('icon',{attrs:{"id":"newPost","name":"circle","scale":"0.7"}}):_vm._e(),_vm._v(" "),_c('h5',[_vm._v(_vm._s(aberto.nm_store))])],1),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1 col-lg-1 text-center"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'aberto', store: aberto.id_store, check: aberto.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1)],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fTzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome___default.a },
  data: function data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      abertos: []
    };
  },

  beforeCreate: function beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/store/own').then(function (response) {
      _this.stores = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].get('/checks/abertos/' + this.admin + '/' + localStorage.getItem('global-store')).then(function (response) {
      _this.spinner = false;
      _this.abertos = response.data;
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        type: 'error',
        title: 'Erro...',
        text: error.response.data.mensagem
      });
    });
  },

  methods: {
    setStore: function setStore() {
      localStorage.setItem('global-store', this.store);
      location.reload();
    }
  }
});

/***/ }),

/***/ "kt5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d16890b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("8bRB");
function injectStyle (ssrContext) {
  __webpack_require__("srZV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d16890b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n9NO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { email: '', password: '' };
  },

  created: function created() {
    // Verifica se existe o item token no localStorage.
    if (localStorage.getItem('token')) this.$router.push('home');
  },
  methods: {
    onSubmit: function onSubmit(event) {
      var _this = this;

      // Não permite o envio do formulário.
      event.preventDefault();

      // Requisição ao webservice.
      __WEBPACK_IMPORTED_MODULE_1__http__["a" /* http */].post('/login', { email: this.email, password: this.password }).then(function (response) {
        // Armazenando o token no localStorage.
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('level', response.data.level);
        localStorage.setItem('admin', response.data.admin);
        localStorage.setItem('stores', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.stores));
        localStorage.setItem('nm_user', response.data.nm_user);
        localStorage.setItem('user', response.data.user);
        localStorage.setItem('global-store', 'all');

        // Definindo o token no headers do axios.
        __WEBPACK_IMPORTED_MODULE_1__http__["a" /* http */].defaults.headers.common['Authorization'] = response.data.token;

        // Redirecionado para a home.
        _this.$router.push('home');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: error.response.data.mensagem
        });
      });
    },
    redefinirSenha: function redefinirSenha(evt) {

      if (this.email != "") {
        __WEBPACK_IMPORTED_MODULE_1__http__["a" /* http */].post('/user/request', { email: this.email }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            icon: 'success',
            title: 'Ok!',
            text: response.data.mensagem
          });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
          icon: 'error',
          title: 'Erro...',
          text: 'Preencha o campo E-mail.'
        });
      }
    }
  }
});

/***/ }),

/***/ "nk/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-success text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" "),_c('h4',[_vm._v("Próximos")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"row pb-4"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store),expression:"store"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.store=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setStore()}]}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todas as Lojas")]),_vm._v(" "),_vm._l((_vm.stores),function(store,index){return _c('option',{key:'store-'+index,domProps:{"value":store.id_store}},[_vm._v(_vm._s(store.nm_store))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('ul',{staticClass:"nav-menu"},[_c('li',[_c('b-link',{staticClass:"active",attrs:{"to":{ name: 'proximos' }}},[_vm._v("Data")])],1),_vm._v(" "),_c('li',[_c('b-link',{attrs:{"to":{ name: 'checklist' }}},[_vm._v("Checklist")])],1)])])]),_vm._v(" "),_vm._l((_vm.proximos.checks),function(proximo,index){return _c('div',{key:'p'+index,staticClass:"row mt-2",attrs:{"id":'proximos-'+index}},[_c('div',{staticClass:"col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(proximo.days))]),_vm._v(" "),(proximo.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(proximo.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-6 col-lg-4"},[_c('span',[_vm._v("\n        "+_vm._s(proximo.nm_check)+"\n        "),(proximo.dt_holiday_dif > 0)?_c('span',{staticClass:"holiday"},[_vm._v("(Férias)")]):_vm._e()]),_vm._v(" "),_c('h5',[_vm._v("\n        "+_vm._s(proximo.nm_store)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-2 col-md-1 col-lg-1 text-center"},[(_vm.level == 'supervisor')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'proximo', store: proximo.id_store, check: proximo.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: proximo.id_store, check: proximo.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1):_vm._e()],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pbl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return { passwordCheck: '', passwordNew: '' };
  },

  created: function created() {
    // Verifica se existe o item token no localStorage.
    if (localStorage.getItem('token')) this.$router.push('home');
  },
  methods: {
    onSubmit: function onSubmit(event) {
      var _this = this;

      // Não permite o envio do formulário.
      event.preventDefault();

      if (this.passwordCheck != this.passwordNew) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
          type: 'error',
          title: 'Erro...',
          text: 'Sua senha não confere, com a confirmação!'
        });
      } else {
        // Requisição ao webservice.
        __WEBPACK_IMPORTED_MODULE_0__http__["a" /* http */].post('/user/password', { passwordCheck: this.passwordCheck, password: this.passwordNew, hash: this.$route.params.hash }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            icon: 'success',
            title: 'Ok!',
            text: response.data.mensagem
          });
          // Redirecionado para a login.
          _this.$router.push('/');
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          });
        });
      }
    }
  }
});

/***/ }),

/***/ "peZ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rPy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-light"},[_c('div',{staticClass:"row title-card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-dark",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.newUser",modifiers:{"newUser":true}}],attrs:{"variant":"success"}},[_vm._v("Novo Usuário")])],1)]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('table',{staticClass:"table table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,index){return _c('tr',{key:'user-'+index},[_c('td',{staticClass:"align-middle"},[(user.st_user == 1)?_c('strong',[_vm._v(_vm._s(user.nm_user))]):[_vm._v(_vm._s(user.nm_user))]],2),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"btn-toolbar float-right",attrs:{"role":"toolbar"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.editUser",modifiers:{"editUser":true}}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.setUser(user)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"pencil","scale":"1.2"}})],1),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.getStores",modifiers:{"getStores":true}}],staticClass:"btn btn-warning",attrs:{"type":"button","disabled":user.st_user == 2},on:{"click":function($event){return _vm.getStores(user)}}},[_c('icon',{staticClass:"align-middle text-white",attrs:{"name":"list","scale":"1.2"}})],1),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.getPermissoesCheck",modifiers:{"getPermissoesCheck":true}}],staticClass:"btn btn-info",attrs:{"type":"button","disabled":user.st_user == 2},on:{"click":function($event){return _vm.getPermissoesCheck(user)}}},[_c('icon',{staticClass:"align-middle text-white",attrs:{"name":"gear","scale":"1.2"}})],1),_vm._v(" "),(user.active == '1')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-success",attrs:{"title":"Desativar"},on:{"click":function($event){return _vm.changeStatus(user)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"check","scale":"1.2"}})],1):_vm._e(),_vm._v(" "),(user.active == '0')?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-danger",attrs:{"title":"Ativar"},on:{"click":function($event){return _vm.changeStatus(user)}}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"ban","scale":"1.2"}})],1):_vm._e()],1)])])])}),0)])])]),_vm._v(" "),_c('b-modal',{ref:"modalNew",attrs:{"id":"newUser","title":"Novo Usuário","no-close-on-backdrop":""},on:{"ok":_vm.newUser,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nnomeUser"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoUsuario.nome),expression:"novoUsuario.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nnomeUser","required":""},domProps:{"value":(_vm.novoUsuario.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novoUsuario, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"ntipoUser"}},[_vm._v("Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoUsuario.tipo),expression:"novoUsuario.tipo"}],staticClass:"custom-select",attrs:{"id":"ntipoUser","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novoUsuario, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Supervisor")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Loja")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.novoUsuario.tipo == 1),expression:"novoUsuario.tipo == 1"}],attrs:{"for":"npermUser"}},[_vm._v("Pode configurar o sistema?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoUsuario.permissao),expression:"novoUsuario.permissao"},{name:"show",rawName:"v-show",value:(_vm.novoUsuario.tipo == 1),expression:"novoUsuario.tipo == 1"}],staticClass:"custom-select",attrs:{"id":"npermUser","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.novoUsuario, "permissao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nemailUser"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoUsuario.email),expression:"novoUsuario.email"}],staticClass:"form-control",attrs:{"type":"email","id":"nemailUser","required":""},domProps:{"value":(_vm.novoUsuario.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novoUsuario, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"npassUser"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoUsuario.pass),expression:"novoUsuario.pass"}],staticClass:"form-control",attrs:{"type":"password","id":"npassUser","required":""},domProps:{"value":(_vm.novoUsuario.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.novoUsuario, "pass", $event.target.value)}}})])])]),_vm._v(" "),_c('b-modal',{ref:"modalEdit",attrs:{"id":"editUser","title":"Editar Usuário","no-close-on-backdrop":""},on:{"ok":_vm.editUser,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"nomeUser"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarUsuario.nome),expression:"editarUsuario.nome"}],staticClass:"form-control",attrs:{"type":"text","id":"nomeUser","required":""},domProps:{"value":(_vm.editarUsuario.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarUsuario, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-6"},[_c('label',{attrs:{"for":"tipoUser"}},[_vm._v("Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarUsuario.tipo),expression:"editarUsuario.tipo"}],staticClass:"custom-select",attrs:{"id":"tipoUser","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarUsuario, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Supervisor")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Loja")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-6"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.editarUsuario.tipo == 1),expression:"editarUsuario.tipo == 1"}],attrs:{"for":"permUser"}},[_vm._v("Pode configurar o sistema?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarUsuario.permissao),expression:"editarUsuario.permissao"},{name:"show",rawName:"v-show",value:(_vm.editarUsuario.tipo == 1),expression:"editarUsuario.tipo == 1"}],staticClass:"custom-select",attrs:{"id":"permUser","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editarUsuario, "permissao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"emailUser"}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarUsuario.email),expression:"editarUsuario.email"}],staticClass:"form-control",attrs:{"type":"email","id":"emailUser","required":""},domProps:{"value":(_vm.editarUsuario.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarUsuario, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"passUser"}},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editarUsuario.pass),expression:"editarUsuario.pass"}],staticClass:"form-control",attrs:{"type":"password","id":"passUser","required":""},domProps:{"value":(_vm.editarUsuario.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editarUsuario, "pass", $event.target.value)}}})])])]),_vm._v(" "),_c('b-modal',{ref:"modalStore",attrs:{"id":"getStores","title":"Permissões (Lojas)","no-close-on-backdrop":""},on:{"ok":_vm.savePermissoes,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-checkbox-group',{attrs:{"stacked":"","name":"stores","options":_vm.permissoes.options},model:{value:(_vm.permissoes.selected),callback:function ($$v) {_vm.$set(_vm.permissoes, "selected", $$v)},expression:"permissoes.selected"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"modalPermissoesCheck",attrs:{"id":"getPermissoesCheck","title":"Permissões (Checks)","no-close-on-backdrop":""},on:{"ok":_vm.savePermissoesCheck,"hidden":_vm.clearData}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('b-form-checkbox',{staticClass:"form-control-sm",attrs:{"id":"checkbox-1","name":"checkbox-1","value":"accepted","value-text":"teste","unchecked-value":"not_accepted"},on:{"change":_vm.statusCheck},model:{value:(_vm.statusCheck_value),callback:function ($$v) {_vm.statusCheck_value=$$v},expression:"statusCheck_value"}},[_c('b',[_vm._v(_vm._s(_vm.statusCheck_text))])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"stacked":"","name":"checks","options":_vm.permissoesCheck.options},model:{value:(_vm.permissoesCheck.selected),callback:function ($$v) {_vm.$set(_vm.permissoesCheck, "selected", $$v)},expression:"permissoesCheck.selected"}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 text-left text-dark"},[_c('h4',[_vm._v("Cadastro de Usuários")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Nome")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"scope":"col"}},[_vm._v("Opções")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6T+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sPvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checklist_vue__ = __webpack_require__("PwEo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a13f01c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checklist_vue__ = __webpack_require__("zWkO");
function injectStyle (ssrContext) {
  __webpack_require__("6xNI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a13f01c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checklist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a13f01c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checklist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "srZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tQ77":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Atrasados_vue__ = __webpack_require__("0FDT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2919c920_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Atrasados_vue__ = __webpack_require__("KHCq");
function injectStyle (ssrContext) {
  __webpack_require__("s6T+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2919c920"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Atrasados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2919c920_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Atrasados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tnWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wbTW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wc4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__ = __webpack_require__("AqTy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4529f8f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ranking_vue__ = __webpack_require__("PYWS");
function injectStyle (ssrContext) {
  __webpack_require__("SY18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4529f8f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ranking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4529f8f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ranking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5712c60d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("J/wO");
function injectStyle (ssrContext) {
  __webpack_require__("01ru")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5712c60d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5712c60d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xgOa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yZHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("AllU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a28177_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("M84A");
function injectStyle (ssrContext) {
  __webpack_require__("wbTW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22a28177"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22a28177_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yaX4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zNoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid text-secondary"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('b-link',{on:{"click":function($event){return _vm.backButton()}}},[_c('span',[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}],attrs:{"name":"cog","scale":"2.5","spin":""}}),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.back),expression:"back"}],attrs:{"name":"arrow-circle-left","scale":"2.5"}})],1)]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.check.nm_store))])],1),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-secondary",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-9 col-sm-10 col-md-10 col-lg-8 col-xl-7 offset-lg-1 offset-xl-2"},[_c('h5',[_vm._v(_vm._s(_vm.check.nm_check))])]),_vm._v(" "),_c('div',{staticClass:"col-3 col-sm-2 col-md-2 col-lg-2 col-xl-1 text-right"},[_c('b-link',{staticClass:"text-secondary",attrs:{"to":{ name: 'history', params: { store: _vm.check.id_store, check: _vm.check.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-lg-10 col-xl-8 offset-lg-1 offset-xl-2"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.check.ds_check.replace(/(?:\r\n|\r|\n)/g, '<br />'))}})])]),_vm._v(" "),(_vm.check.status == 'novo')?[_c('div',{staticClass:"row no-gutters justify-content-center text-white text-center text-uppercase mt-4 botoes"},[_c('div',{staticClass:"col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-success pt-2",on:{"click":function($event){return _vm.checkOk()}}},[_c('icon',{attrs:{"name":"check-circle","scale":"3"}}),_c('br'),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-danger pt-2",on:{"click":function($event){return _vm.checkFail()}}},[_c('icon',{attrs:{"name":"times-circle","scale":"3"}}),_c('br'),_vm._m(1)],1),_vm._v(" "),_c('div',{staticClass:"col-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 bg-warning pt-2",on:{"click":function($event){return _vm.checkOpen()}}},[_c('icon',{attrs:{"name":"exclamation-circle","scale":"3"}}),_c('br'),_vm._m(2)],1)])]:_vm._e(),_vm._v(" "),(_vm.check.status == 'aberto')?[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-lg-10 col-xl-8 offset-lg-1 offset-xl-2 bg-white text-white mensagens"},[_c('ul',{staticClass:"m-2"},[(_vm.messages == 0)?_c('li',[_c('p',{staticClass:"text-secondary text-center"},[_vm._v("SEM MENSAGENS")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.messages),function(message,index){return _c('li',_vm._b({key:'m-'+index,class:message.align},'li',_vm.mainProps,false),[_c('p',{staticClass:"p-0 m-0"},[_c('small',[_vm._v(_vm._s(message.dt_message)+" - "+_vm._s(message.nm_sender))])]),_vm._v(" "),(message.tp_message == 'txt')?_c('p',{staticClass:"p-0 m-0",domProps:{"innerHTML":_vm._s(message.ds_message.replace(/(?:\r\n|\r|\n)/g, '<br />'))}}):_vm._e(),_vm._v(" "),(message.tp_message == 'img')?_c('p',{staticClass:"p-0 m-0"},[_c('img',_vm._b({staticClass:"img-fluid",attrs:{"src":message.ds_message},on:{"click":function($event){return _vm.openImg(message.ds_message)}}},'img',_vm.mainProps,false))]):_vm._e(),_vm._v(" "),(message.tp_message == 'arq')?_c('p',{staticClass:"p-0 m-0",attrs:{"title":"Download"}},[_c('a',{attrs:{"href":message.ds_message,"target":"_blank"}},[_c('icon',{staticClass:"align-middle",attrs:{"name":"download","scale":"4"}})],1)]):_vm._e()])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-2"},[_c('div',{staticClass:"col-lg-10 col-xl-8 offset-lg-1 offset-xl-2"},[_c('div',{staticClass:"input-group mb-3"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newMessage),expression:"newMessage"}],staticClass:"form-control",attrs:{"placeholder":"Mensagem","id":"newMessage","rows":"3","maxlength":"500","required":""},domProps:{"value":(_vm.newMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newMessage=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-secondary text-light btm-send",on:{"click":function($event){return _vm.sendMessage()}}},[_c('icon',{attrs:{"name":"caret-right","scale":"1"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters mt-0"},[_c('input',{staticClass:"d-none",attrs:{"type":"file","accept":"*","id":"camera"},on:{"change":_vm.onFileChange}}),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4  offset-lg-1 offset-xl-2"},[(_vm.level == 'supervisor')?_c('button',{staticClass:"btn btn-success text-white",attrs:{"type":"submit"},on:{"click":function($event){return _vm.checkClose(0)}}},[_vm._v("Tudo Certo")]):_vm._e(),_vm._v(" "),(_vm.level == 'supervisor')?_c('button',{staticClass:"btn bg-danger text-white",attrs:{"type":"submit"},on:{"click":function($event){return _vm.checkClose(1)}}},[_vm._v("Tem Problema Aqui")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4 text-right"},[_c('button',{staticClass:"btn btn-secondary btn-camera",on:{"click":function($event){return _vm.openCamera()}}},[_c('icon',{attrs:{"name":"upload","scale":"1.5"}})],1)])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-footer":""}},[_c('div',{staticClass:"d-block text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.openImage}})])])]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Tudo"),_c('br'),_vm._v("Certo")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Tem"),_c('br'),_vm._v("Problema"),_c('br'),_vm._v("Aqui")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Apenas"),_c('br'),_vm._v("Considerações")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zWkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-success text-white"},[_c('div',{staticClass:"row title-card"},[_c('div',{staticClass:"col-10 text-left"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.spinner),expression:"spinner"}]},[_c('icon',{attrs:{"name":"cog","scale":"2.5","spin":""}})],1),_vm._v(" "),_c('h4',[_vm._v("Próximos")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-right"},[_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'home' }}},[_c('icon',{attrs:{"name":"times","scale":"2"}})],1)],1)]),_vm._v(" "),(_vm.level == 'supervisor')?_c('div',{staticClass:"row pb-4"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store),expression:"store"}],staticClass:"custom-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.store=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setStore()}]}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todas as Lojas")]),_vm._v(" "),_vm._l((_vm.stores),function(store,index){return _c('option',{key:'store-'+index,domProps:{"value":store.id_store}},[_vm._v(_vm._s(store.nm_store))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('ul',{staticClass:"nav-menu"},[_c('li',[_c('b-link',{attrs:{"to":{ name: 'proximos' }}},[_vm._v("Data")])],1),_vm._v(" "),_c('li',[_c('b-link',{staticClass:"active",attrs:{"to":{ name: 'checklist' }}},[_vm._v("Checklist")])],1)])])]),_vm._v(" "),_vm._l((_vm.checklist),function(store,index){return [_c('div',{key:'s'+index,staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('h5',[_vm._v(_vm._s(store.nm_store))])])]),_vm._v(" "),_vm._l((store.groups),function(group,index){return [(group.view == 'S')?_c('div',{key:'g-'+store.id_store+index,staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3"},[_c('h6',[_vm._v(_vm._s(group.nm_group))]),_vm._v(" "),_vm._l((group.checks),function(checklist,index){return _c('div',{key:'c'+index,staticClass:"row",attrs:{"id":'checklist-'+index}},[_c('div',{staticClass:"col-2 text-center"},[_c('strong',{staticClass:"d-block"},[_vm._v(_vm._s(checklist.days))]),_vm._v(" "),(checklist.days == 1)?_c('span',[_vm._v("dia")]):_vm._e(),(checklist.days > 1)?_c('span',[_vm._v("dias")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8 text-truncate"},[_c('span',[_vm._v("\n                "+_vm._s(checklist.nm_check)+"\n                "),(checklist.dt_holiday_dif > 0)?_c('span',{staticClass:"holiday"},[_vm._v("(Férias)")]):_vm._e()]),_vm._v(" "),_c('h5',[_vm._v("\n                "+_vm._s(checklist.nm_store)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center"},[(_vm.level == 'supervisor')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'check', params: { type: 'proximo', store: store.id_store, check: checklist.id_check }}}},[_c('icon',{attrs:{"name":"edit","scale":"2"}})],1):_vm._e(),_vm._v(" "),(_vm.level == 'store')?_c('b-link',{staticClass:"text-white",attrs:{"to":{ name: 'history', params: { store: store.id_store, check: checklist.id_check }}}},[_c('icon',{attrs:{"name":"info-circle","scale":"2"}})],1):_vm._e()],1)])})],2)]):_vm._e()]})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ef7727f7ccfece5a0dce.js